export const ANSWERS = { NOT_ANSWERED: 1, ADD_TO_CART: 2, NOT_OK: 3, CONTACT_ME: 4 };
